export default {"src":"/_next/static/media/gg_loadbar-doc.81d9a908.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};